<app-ya-metric *ngIf="codes$ | async as codes" [codes]="codes"></app-ya-metric>
